<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-20">
            My Success Roadmap
        </div>
        <div class="content padding-10 card round-medium" :style="loadBg">
            <div class="content">
                <div class="content-desc margin-top-30 margin-bottom-5 text-left">
                    Discover 1-3-5<br>
                    Builder Path with Generali Life Insurance Malaysia 
                </div>
            
           
                <div>
                    <div class="ipad-display text-center">
                        <img :src="'images/mpower-new/my_success_roadmap/iPad/01.png'" class="img-resize ipad">
                    </div>
                    <div class="mobile-display">
                        <img v-bind:src="'images/mpower-new/my_success_roadmap/mobile/01.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    </div>
                </div>

                <div class="content-desc margin-top-30 margin-bottom-5 text-left">
                    Promotion From<br>
                    Agent to Unit Manager
                </div>

                <div>
                    <div class="ipad-display text-center">
                        <img :src="'images/mpower-new/my_success_roadmap/iPad/02.png'" class="img-resize ipad">
                    </div>
                    <div class="mobile-display">
                        <img v-bind:src="'images/mpower-new/my_success_roadmap/mobile/02.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    </div>
                </div>

                <div class="content-desc  margin-top-30 margin-bottom-5 text-left">
                    Promotion From<br>
                    Unit Manager to Agency Manager
                </div>

                <div>
                    <div class="ipad-display text-center">
                        <img :src="'images/mpower-new/my_success_roadmap/iPad/03.png'" class="img-resize ipad">
                    </div>
                    <div class="mobile-display">
                        <img v-bind:src="'images/mpower-new/my_success_roadmap/mobile/03.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    </div>
                </div>

                <div class="content-desc  margin-top-30 margin-bottom-5 text-left">
                    Producer earn RM 2 Mil<br>
                    in 5 Years
                </div>

                <div>
                    <div class="ipad-display text-center">
                        <img :src="'images/mpower-new/my_success_roadmap/iPad/04.png'" class="img-resize ipad">
                    </div>
                    <div class="mobile-display">
                        <img v-bind:src="'images/mpower-new/my_success_roadmap/mobile/04.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    </div>
                </div>

                <div class="content-desc  margin-top-30 margin-bottom-5 text-left">
                    Success Formula
                </div>

                <div>
                    <div class="ipad-display text-center">
                        <img :src="'images/mpower-new/my_success_roadmap/iPad/05.png'" class="img-resize ipad">
                    </div>
                    <div class="mobile-display">
                        <img v-bind:src="'images/mpower-new/my_success_roadmap/mobile/05.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    </div>
                </div>

                <div class="content-extra-desc margin-top-30">
                    With 3 presentations a day, 5 days a week and 48 weeks a year consistent sales presentation, you can easily generate 324,000 PVI a year! 
                </div>
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mx-auto {
    margin: 0 auto;
}
.important-text {
    color: #DB3C37;
}
@media(min-width: 765px){
    .ipad-responsive-img {
        max-width: 60% !important;
    }
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
export default {
    name: 'Roadmap',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        }
    },
    components: {
        RoadmapNav
    }
}
</script>
